import { render } from "./GaleryAdmin.vue?vue&type=template&id=3630a1d0&scoped=true"
import script from "./GaleryAdmin.vue?vue&type=script&lang=js"
export * from "./GaleryAdmin.vue?vue&type=script&lang=js"

import "./GaleryAdmin.vue?vue&type=style&index=0&id=3630a1d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3630a1d0"]])

export default __exports__